<p-table [value]="irpfTableService.rows()">
    <ng-template pTemplate="header">
        <tr>
            <th rowspan="2" style="text-align:center; vertical-align:middle;">{{ 'IRPF.HEADERS.CONCEPT' | translate }}</th>
            <th colspan="4" style="text-align:center; vertical-align:middle;">
                <div class="centered-label-and-info">
                    <span>{{ 'IRPF.HEADERS.IRPF_TYPE' | translate }}</span>
                    @if (!irpfTableService.irpfInfo.isKnownEstimation){
                        <span class="material-symbols-outlined" style="font-size: 18px;" [pTooltip]="'IRPF.INFORMATION.UNKNOWN_ESTIMATION' | translate" tooltipPosition="top">info</span>
                    }
                </div>
            </th>
        </tr>
        <tr>
            <th style="text-align:center; vertical-align:middle;">{{ 'IRPF.HEADERS.DIRECT_ESTIMATION' | translate }}</th>
            <th style="text-align:center; vertical-align:middle;">{{ 'IRPF.HEADERS.SIMPLIFIED_DIRECT_ESTIMATION' | translate }}</th>
            <th style="text-align:center; vertical-align:middle;">{{ 'IRPF.HEADERS.OBJECTIVE_ESTIMATION' | translate }}</th>
            <th style="text-align:center; vertical-align:middle;">{{ 'IRPF.HEADERS.OBJECTIVE_ESTIMATION_AGRICULTURAL_LIVESTOCK_FORESTRY' | translate }}</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
        <tr>
            @if (row.isCategoryHeader) {
                <td colspan="5"><strong>{{ row.category | translate }}</strong></td>
            } @else {
                <td>
                    <div class="label-and-info">
                        <span>{{ row.concept | translate }}</span>
                        @if (isRentsRow(row.concept)){
                            <span class="material-symbols-outlined" style="font-size: 18px;" [pTooltip]="'IRPF.INFORMATION.RENTS' | translate" tooltipPosition="top">info</span>
                        }
                    </div>
                </td>
                @if (row.isSingleRow){
                    <td colspan="4" style="text-align:center;">{{ irpfTableService.getSingleRowFormattedValue(row) }}</td>
                } @else {
                    <td style="text-align:center;">{{ row.DirectEstimation !== null ? (row.DirectEstimation | number:'1.0-2':'es-ES') : 'N/A' }}</td>
                    <td style="text-align:center;">{{ row.SimplifiedDirectEstimation !== null ? (row.SimplifiedDirectEstimation | number:'1.0-2':'es-ES') : 'N/A' }}</td>
                    <td style="text-align:center;">{{ row.ObjectiveEstimation !== null ? (row.ObjectiveEstimation | number:'1.0-2':'es-ES') : 'N/A' }}</td>
                    <td style="text-align:center;">{{ row.ObjectiveEstimationAgriculturalLivestockForestry !== null ? (row.ObjectiveEstimationAgriculturalLivestockForestry | number:'1.0-2':'es-ES') : 'N/A' }}</td>
                }
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="footer">
    <tr>
        <td colspan="5" style="text-align:center; padding: 10px;">
        <span>
            {{ "IRPF.FOOTER.DOWNLOAD_MESSAGE" | translate }}
            <a (click)="downloadExcel()" (keydown)="downloadExcel()" tabindex="0" style="text-decoration: underline; cursor: pointer;">
            {{ "IRPF.FOOTER.CLICK_HERE" | translate }}
            </a>
        </span>
        </td>
    </tr>
    </ng-template>
</p-table>
